export default __webpack_public_path__ + "static/media/EV-Stats.0154c675.png";